import React from 'react';
import { array } from 'prop-types';

import { namespace } from './common';
import { Renderer } from './components/render-types';

export const Components = ({ components }) =>
  components?.length > 0 && (
    <div className={`${namespace}__components-container`}>
      {components.map(({ id, key: _, ...props }) => (
        <Renderer key={id} {...props} />
      ))}
    </div>
  );

Components.propTypes = {
  components: array,
};
